define('views/text-setting',["require", "exports", "../notifications"], function (require, exports, notifications) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TextSetting = exports.TextSettingMode = void 0;
    // Behavior when user clicks edit
    var TextSettingMode;
    (function (TextSettingMode) {
        TextSettingMode[TextSettingMode["SelectAll"] = 0] = "SelectAll";
        TextSettingMode[TextSettingMode["SelectEnd"] = 1] = "SelectEnd"; // move cursor to end of text
    })(TextSettingMode = exports.TextSettingMode || (exports.TextSettingMode = {}));
    // A component that shows fixed text by default but can be edited by the user
    var TextSetting = /** @class */ (function () {
        function TextSetting(options) {
            var _this = this;
            this.options = options;
            this.span = options.element.querySelector("span");
            if (!options.element)
                return;
            var input = options.element.querySelector("input");
            var link = options.element.querySelector("a");
            if (link) {
                link.addEventListener("click", function (e) {
                    options.element.classList.add("editing");
                    input.focus();
                    if (options.selectMode === TextSettingMode.SelectAll) {
                        input.select();
                    }
                    else if (options.selectMode === TextSettingMode.SelectEnd) {
                        input.selectionStart = input.value.length;
                    }
                    e.stopPropagation();
                });
            }
            if (input) {
                input.onkeypress = function (e) {
                    var code = e.which || e.keyCode;
                    if (code === 13) { // Enter
                        _this.commit(input.value);
                    }
                };
                input.onkeyup = function (e) {
                    var code = e.which || e.keyCode;
                    if (code === 27) { // Esc
                        // Revert text
                        input.value = _this.span.innerText;
                        _this.close();
                    }
                    e.stopPropagation();
                };
                input.addEventListener("blur", function () {
                    if (_this.options.closeOnBlur && input.value === _this.span.innerText) {
                        _this.close();
                    }
                });
            }
        }
        TextSetting.prototype.commit = function (value) {
            var _this = this;
            if (this.span.innerText !== value) {
                // Update ui
                this.span.innerText = value;
                this.span.classList.remove("text-danger");
                // Save to server
                this.options.save(value)
                    .catch(function (e) {
                    _this.span.classList.add("text-danger");
                    notifications.error(e.message);
                });
            }
            this.close();
        };
        TextSetting.prototype.close = function () {
            this.options.element.classList.remove("editing");
        };
        return TextSetting;
    }());
    exports.TextSetting = TextSetting;
});
//# sourceMappingURL=/assets/javascripts/views/text-setting.js.map;
